function FakeCard() {
  return (
    <div className="rounded-lg bg-brand-white border border-b-1 border-b-brand-gray">
      <div className="bg-brand-mediumgray object-cover object-center rounded-t-md animate-pulse h-52 w-full"></div>
      <div className="px-4 py-2 flex flex-col gap-2">
        <div className="h-6 rounded-md w-8/12 bg-brand-mediumgray animate-pulse"></div>
        <div className="flex gap-1 animate-pulse flex-wrap">
          <div className="h-5  w-11 rounded-md bg-brand-mediumgray"></div>
          <div className="h-5 w-11 rounded-md bg-brand-mediumgray"></div>
          <div className="h-5 w-11 rounded-md bg-brand-mediumgray"></div>
        </div>
        <div className="h-5 animate-pulse w-8/12 rounded-md bg-brand-mediumgray"></div>
      </div>
    </div>
  );
}

const getGrid = (rows) => {
  const available = {
    3: "md:grid-cols-2 lg:grid-cols-3",
    4: "md:grid-cols-2 lg:grid-cols-4",
  };
  return available[rows];
};

export default function Loading({ elementsPerRow = 4 }) {
  return (
    <div className={`grid w-full mb-4 ${getGrid(elementsPerRow)} gap-8`}>
      {new Array(12).fill(0).map((el, index) => {
        return <FakeCard key={index} />;
      })}
    </div>
  );
}
